import { FC } from "react";
import { useSelector } from "react-redux";
import { Currency } from "../../common/constants";
import { NumberMoney } from "../../components/NumberMoney/NumberMoney";
import { AppState } from "../main.reducer";
import { usePictures } from "../Pictures/usePictures";

export const PackageContent: FC<{ showTitle?: boolean }> = ({
  showTitle = true,
}) => {
  const { equipmentPrice } = usePictures();
  const currency = useSelector<AppState, Currency>(
    (store) => store.common.currency,
  );
  const isKM = currency === "KM";

  return (
    <>
      {showTitle && (
        <>
          <div
            className="cursive f18"
            style={{ color: "var(--ion-color-dark)" }}
          >
            Sadržaj seta
          </div>
          <br />
        </>
      )}
      <div
        className={showTitle ? "cursive f14" : "cursive f18"}
        style={{ color: showTitle ? "" : "var(--ion-color-dark)" }}
      >
        Osnovni set za bojenje sadrži:
      </div>
      <ul style={{ paddingLeft: "15px" }}>
        <li>
          <strong>Urolano</strong> slikarsko platno dimenzija 40x50 cm{" "}
          <strong>(bez blind rama)</strong>, sa odštampanim konturama izabranog
          motiva
        </li>
        <li>Sve potrebne akrilne boje, pripremljene i označene brojevima</li>
        <li>3 četkice (2 za precizno bojenje + 1 za veće površine)</li>
        <li>2 kukice za kačenje na zid</li>
        <li>Uputstvo za upotrebu</li>
        <li>Kontrolni list</li>
        <li>Račun</li>
      </ul>
      {isKM ? "Cijena:" : "Cena:"}{" "}
      <NumberMoney value={equipmentPrice.typicalPriceRegular} /> + poštarina.
      <br />
      <br />
      <div
        className={showTitle ? "cursive f14" : "cursive f18"}
        style={{ color: showTitle ? "" : "var(--ion-color-dark)" }}
      >
        Dodatna ponuda:
      </div>
      <br />
      {isKM ? (
        <>
          <strong>Blind ram</strong>
          <ul style={{ paddingLeft: "15px" }}>
            <li>
              Rasklopljen blind ram –{" "}
              <NumberMoney value={equipmentPrice.frame} /> (kupac sam montira i
              zateže platno)
            </li>
            <li>Drveni i aluminijski štafelaji</li>
            <li>Mogućnost naručivanja dodatnih boja</li>
          </ul>
        </>
      ) : (
        <>
          Blind ram – dve opcije:
          <ul style={{ paddingLeft: "15px" }}>
            <li>
              Rasklopljen blind ram –{" "}
              <NumberMoney value={equipmentPrice.frame} /> (kupac sam montira i
              zateže platno)
            </li>
            <li>
              Blind ram sa montažom –{" "}
              <NumberMoney value={equipmentPrice.frameAssembled} /> (uključuje
              zatezanje platna; cena montaže{" "}
              <NumberMoney
                value={equipmentPrice.frameAssembled - equipmentPrice.frame}
              />
              )
            </li>
          </ul>
          <ul style={{ paddingLeft: "15px" }}>
            <li>Drveni i aluminijumski štafelaji</li>
            <li>Mogućnost poručivanja dodatnih boja</li>
          </ul>
        </>
      )}
      <div
        className={showTitle ? "cursive f14" : "cursive f18"}
        style={{ color: showTitle ? "" : "var(--ion-color-dark)" }}
      >
        Dečiji set „za najmlađe" sadrži:
      </div>
      <ul style={{ paddingLeft: "15px" }}>
        <li>
          Slikarsko platno <strong>na blind ramu</strong> dimenzija 20x20 cm sa
          odštampanim konturama
        </li>
        <li>Sve potrebne akrilne boje, pripremljene i označene brojevima</li>
        <li>2 četkice (1 za precizno bojenje + 1 za veće površine)</li>
        <li>2 kukice za kačenje na zid</li>
        <li>Uputstvo za upotrebu</li>
        <li>Kontrolni list</li>
        <li>Račun</li>
      </ul>
      {isKM ? "Cijena:" : "Cena:"}{" "}
      <NumberMoney value={equipmentPrice.typicalPriceKids} /> + poštarina.
      <br />
      <br />
    </>
  );
};

const Flag: FC<{ src: string; alt: string }> = ({ src, alt }) => (
  <img src={src} alt={alt} style={{ width: "1.4em" }} />
);

export const DeliveryText = ({ centered }: { centered?: boolean }) => {
  const justify = centered ? "center" : undefined;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: justify,
      }}
    >
      <div style={{ textAlign: justify }}>Rok isporuke:</div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.4em",
          justifyContent: justify,
        }}
      >
        <Flag src="assets/flags/SRB.svg" alt="Srbija" />
        Srbija: 2 – 4 radna dana
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.4em",
          justifyContent: justify,
        }}
      >
        <Flag src="assets/flags/BIH.svg" alt="Bosna i Hercegovina" />
        Bosna i Hercegovina: 3 – 6 radnih dana
      </div>
    </div>
  );
};

export const PackageDelivery: FC = () => {
  const { equipmentPrice } = usePictures();
  const currency = useSelector<AppState, Currency>(
    (store) => store.common.currency,
  );
  const isKM = currency === "KM";

  return (
    <>
      <div className="cursive f18" style={{ color: "var(--ion-color-dark)" }}>
        Poštarina i isporuka
      </div>
      <br />
      <p className="f13 ion-text-justify">
        Poštarina: <NumberMoney value={equipmentPrice.shipping} />.
        <br />
        <br />
        {isKM ? "Cijena" : "Cena"} poštarine je fiksna. Ukoliko kupac kupi više
        proizvoda, sve se pakuje u jedan paket i naplaćuje jedna poštarina.
        <br />
        {isKM && (
          <>
            <strong>Maksimalna vrijednost jednog paketa je 280 KM.</strong>
            <br />
          </>
        )}
        Plaćanje se vrši kuriru prilikom preuzimanja (pouzećem)
        <br />
        <br />
        <DeliveryText />
      </p>
    </>
  );
};
